import { useState } from "react";

import { useApiClient } from "../../api-client";

const useRequestPinCard = () => {
  const { get } = useApiClient();
  const [isLoading, setIsLoading] = useState(false);

  const requestPinCard = async ({ cardId }: { cardId: string }) => {
    setIsLoading(true);
    const { data } = await get(`/v2/cards/${cardId}/pin`);
    setIsLoading(false);

    if (data && data.source) {
      return { source: data.source };
    }

    return { source: null };
  };

  return {
    isLoading,
    requestPinCard,
  };
};

export { useRequestPinCard };
